module.exports = __webpack_public_path__ + "img/flag-IT.9779f339.png";